<template>
  <div
    class="gwnl-web-position-detail-skills-standard"
    :class="{'mt36': (tagStyle && type===1)}"
  >
    <div class="gwnl-web-position-detail-skills-standard-header">
      <div
        class="flex-1 align-items-center ellipsis font-size-14 lh22"
      >
        <yxt-svg
          class="mr8"
          :remote-url="gwnlMediaDomain + 'svg/'"
          style="width: 20px; height: 20px;"
          width="20"
          height="20"
          :icon-class="type===1? 'adv': 'disadv'"
        />
        {{ type===0?$t('pc_gwnl_ability_standard'):type===1?$t('pc_gwnl_web_advantageAbility'):$t('pc_gwnl_web_disadvantageAbility') }}
      </div>
      <template
        v-if="detail.length>0 && !tagStyle"
      >
        <div
          v-for="(legend, index) in legends"
          :key="index"
          class="standard-size-12 color-gray-7 ml16 align-items-center lh20"
        >
          <i
            class="skill_detail-legend mr8"
            :class="{'bg-gray': index===0, 'bg-yellow': (index >0 && type===2), 'bg-blue': (index >0 && type===1)}"
          />{{ legend.label }}
        </div>
      </template>
    </div>
    <div
      v-if="detail.length>0"
      class="gwnl-web-position-detail-skills-standard-content mt16"
    >
      <template
        v-if="!tagStyle"
      >
        <div
          v-for="(item) in detail"
          :key="item.id"
          class="gwnl-web-position-detail-skills-standard-content-item mb24"
        >
          <div class="standard-size-12 color-gray-9 flex mb10">
            <yxtf-tooltip
              open-filter
              :content="item.name"
              placement="top"
            >
              <div class="ellipsis maxWidth142">
                {{ item.name }}
              </div>
            </yxtf-tooltip>
          </div>
          <detail-progress
            v-for="(legend, index) in legends"
            :key="index"
            :color="index > 0 ? (type===2 ? '#FA8C16' : '#4943FF') : '#cdd1e0'"
            :level="+item[legend.propName]"
            :level-name="item[legend.propLevelName]"
            :range4show="item[legend.propRange]"
          />
        </div>
      </template>
      <div
        v-for="(item,itemIndex) in detail"
        v-else
        :key="item.id"
        class="gwnl-web-position-detail-skills-standard-content-item-tags ellipsis font-size-12 lh17 pv6 ph12 mt14 maxWidth158"
        :class="{'mr16': itemIndex !==detail.length-1}"
      >
        {{ item.name }}
      </div>
    </div>
    <yxtf-empty
      v-else
      class="mb47"
    />
  </div>
</template>

<script>
import detailProgress from './detailProgress';
import { GWNL_MEDIA_DOMAIN } from 'yxt-biz-pc/packages/ability-preview/src/components/domain.js';

export default {
  components: {
    detailProgress
  },
  props: {
    tagStyle: {
      type: Boolean,
      default: false // 标签样式
    },
    catalog: {
      type: Number,
      default: 1
    },
    type: {
      type: Number,
      default: 0 // 0-岗位标准，1-区分优势、劣势
    },
    legends: {
      type: Array,
      default: () => {
        return [];
      }
    },
    detail: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      gwnlMediaDomain: GWNL_MEDIA_DOMAIN
    };
  }
};
</script>
<style lang="scss" scoped>
.skill_detail-legend {
  display: inline-block;
  width: 12px;
  height: 4px;
  border-radius: 3px;
}

.align-items-center {
  display: flex;
  align-items: center;
}
.bg-yellow {
  background-color: #fa8c16;
}

.bg-blue {
  background-color: #4943ff;
}

.bg-gray {
  background-color: #cdd1e0 !important;
}

.bg-primary {
  background-color: var(--color-primary-6);
}

.gwnl-web-position-detail-skills-standard-content-item-tags {
  max-width: 158px;
  color: #262626;
  background: #f5f5f5;
  border-radius: 17px;
}

.maxWidth158 {
  max-width: 158px;
}
</style>
